import { supabase } from '@/lib/supabase'

/**
 * The one place the generated types are bypassed.
 *
 * `src/db/database.types.ts` is generated by `npm run types:generate`, and it
 * does not know about a function until that has been re-run. Rather than
 * scatter casts through the screens, every RPC goes through here, and this
 * comment is the reminder that the safety net is missing at exactly this line.
 *
 * Regenerating is worth doing after any migration that adds a function:
 *
 *   npm run types:generate
 */
type RpcFn = (
  name: string,
  args?: Record<string, unknown>,
) => Promise<{ data: unknown; error: { message: string } | null }>

export async function rpc<T>(name: string, args?: Record<string, unknown>): Promise<T> {
  const { data, error } = await (supabase.rpc as unknown as RpcFn)(name, args)
  if (error !== null) throw new Error(`${name}: ${error.message}`)
  return data as T
}
